import { render, staticRenderFns } from "./TipoDependencia.vue?vue&type=template&id=59b4b9f0&"
import script from "./TipoDependencia.vue?vue&type=script&lang=js&"
export * from "./TipoDependencia.vue?vue&type=script&lang=js&"
import style0 from "./TipoDependencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports